* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: calc(7 * var(--spacer)) calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2 * var(--spacer));
  display: flex;
  flex-direction: column;

  height: 100%;
}

.title-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding-bottom: var(--spacer);
}

.title-header-text {
  font-family: 'Montserrat Medium', 'Montserrat', sans-serif;
  font-size: var(--display-2-size);
  font-weight: 500;
  color: var(--main-titles-inputs-600);
}

.title-header-link {
  font-family: 'Montserrat', sans-serif;
  font-size: var(--body-size-xsmall);
  text-decoration: underline;
  color: var(--blue-layout-400-primary);
}

#schema-helper-input-search {
  padding-top: var(--spacer);
  padding-bottom: calc(1.5 * var(--spacer));
}

#schema-helper-os-filter {
  padding-bottom: calc(1.5 * var(--spacer));
  --form-field-input-width: 500px;
}

.tables-header {
  display: flex;
  justify-content: flex-start;
  align-content: center;

  gap: calc(2 * var(--spacer));
  padding-left: var(--spacer);
  padding-top: var(--spacer);
  padding-bottom: var(--spacer);
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
  border-top: 1px solid var(--chart-101-pressed-dividers);
}

.tables-header-title {
  font-family: 'Montserrat SemiBold', 'Montserrat', sans-serif;
  font-weight: bold;
  font-size: var(--body-size-small);
  color: var(--chart-300-icon-buttons);
}

.tables-header-nr-of-tables {
  font-family: 'Montserrat', sans-serif;
  font-size: var(--body-size-xxsmall);
}

#no-results-message {
  font-style: italic;
}

.columns-content {
  display: flex;
  justify-content: space-between;

  padding-top: calc(var(--spacer) / 2);
  padding-bottom: calc(var(--spacer) / 2);
}

.columns-content:hover {
  background-color: var(--chart-050-hover);
}

.column-type {
  font-family: 'Montserrat Italic', 'Montserrat', sans-serif;
  font-style: italic;
  font-size: var(--body-size-xsmall);
}

.columns {
  display: flex;
  flex-direction: column;

  padding-top: var(--spacer);
  padding-bottom: calc(2 * var(--spacer));
}

.element-description {
  padding-top: var(--spacer);
  padding-bottom: var(--spacer);

  font-size: var(--body-size);
}

.title-text {
  font-family: var(--font-family);
  font-size: var(--body-size);

  color: var(--surface-1-text);
}

.title-text-bold {
  font-weight: bold;
}

.column-text {
  font-size: var(--body-size);
}

.column-text-bold {
  font-size: var(--body-size);
  font-weight: bold;
}

.platforms {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  gap: var(--spacer);
  padding-top: var(--spacer);
  padding-bottom: var(--spacer);
}

.platforms-images {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  gap: var(--spacer);
}

.platforms-text {
  font-family: 'Montserrat Italic', 'Montserrat', sans-serif;
  font-style: italic;
  font-size: var(--body-size);

  color: var(--chart-300-icon-buttons);
}

#schema-helper-accordions {
  height: 100%;
  overflow: auto;
}

// ToDo: see if I really need this
body::-webkit-scrollbar-track {
  background: var(--white-layout-300-primary);
}

body::-webkit-scrollbar-thumb {
  background-color: var(--chart-300-icon-buttons);
  border-radius: 6px;
}
